<template>
  <div class="page" style="margin-left: 200px">
    <el-card class="card" :body-style="{ padding: '20px 20px 0 20px' }">
      <div style="display: flex; justify-content: space-between">
        <div class="header">
          <span
            :class="showView == 1 ? 'showViewClass' : 'viewClass'"
            @click="showView = 1"
            >{{ $t('DomesticMarineTransportation.DataStatistics') }}</span
          >
          <div
            style="
              width: 2px;
              height: 16px;
              margin: 3px 8px;
              background-color: #9c9c9c;
            "
          />
          <span
            :class="showView == 2 ? 'showViewClass' : 'viewClass'"
            @click="showView = 2"
            >{{ $t('DomesticMarineTransportation.OrderInquiry') }}</span
          >
        </div>
        <div
          v-if="showView === 2"
          class="scription-center"
          @click="showScription()"
        >
          <i class="el-icon-collection" style="margin-right: 4px"></i
          >{{ $t('DomesticMarineTransportation.SubscriptionCenter') }}
        </div>
      </div>
    </el-card>
    <div v-if="showView === 1">
      <DataStatistics :customer-code.sync="customerCode" />
    </div>
    <div v-if="showView === 2">
      <MMorderSearch :customer-code.sync="customerCode" />
    </div>
    <div class="disclaimer">
      <div>
        <p>
          &nbsp;<img
            src="@/assets/fms/disclaimerIcon.svg"
            style="display: inline"
          />&nbsp;{{ $t('SeaFreight.Disclaimer') }}
        </p>
      </div>
    </div>
    <ScriptCenter
      ref="scriptCenter"
      @success="$refs.SubscriptionSuccess.open()"
    />
    <SubscriptionSuccess ref="SubscriptionSuccess" />
  </div>
</template>
<script>
import DataStatistics from './modules/dataStatistics.vue'
import MMorderSearch from './modules/mmorderSearch.vue'
import { USER_INFO } from '@/store/mutation-types'
import { ClickMenu } from '@/api/air/order/index'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
export default {
  components: {
    DataStatistics,
    MMorderSearch,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {
    return {
      showView: 1,
      customerCode: '',
      lang: 'zh'
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
  },
  mounted() {
    const params = {
      id: 3
    }
    ClickMenu(params)
    this.lang = this.$ls.get('lang');
  },
  created() {
    this.customerCode = (this.$route.customerCode && this.$route.query.customerCode) ?? this.userInfo.CACode
  },
  methods: {
    showScription() {
      this.$refs.scriptCenter.open('FMS_WT_MM')
    },
  }
}
</script>
<style scoped>
.scription-center {
  border: 1px solid #53a2b6;
  color: #53a2b6;
  height: 30px;
  line-height: 18px;
  border-radius: 4px;
  padding: 4px 16px;
  cursor: pointer;
}
.mtf1 {
  float: right;
  margin-top: -1px;
  border-top: #fff;
}
.page >>> .el-card.is-always-shadow {
  box-shadow: initial !important;
}
.page {
  padding: 10px;
  background: #f0f6fb;
  min-width: 1200px;
}
.page .card .header {
  float: left;
  display: flex;
  line-height: 22px;
  font-weight: bold;
}
.page .card .header .viewClass {
  color: #9c9c9c;
  cursor: pointer;
}
.page .card .header .showViewClass {
  color: #59b9d3;
  cursor: pointer;
}
.elSelect {
  width: 150px;
  margin-left: 10px;
  margin-right: 20px;
  border-radius: 8px;
}
.header {
  font-size: 18px;
}
.disclaimer {
  position: fixed;
  left: 210px;
  bottom: 0;
  right: 0;
  background: #f0f6fc;
  color: #8ca2bd;
  opacity: 0.85;
  font-size: 12px;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
</style>
